import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@mui/material";
import { FC, useEffect, useState } from "react"
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { getGruposEstrutura, getLimitacoesProjetos, grupoEstrutura$, limitacoes$ } from "src/store/global.store";
import styled from "styled-components";
import { Revisao } from "./RevisaoProjeto";
import { Projeto } from "./types";

interface ResumoRevisaoProperties {
    open: boolean;
    revisao: Revisao;
    projeto: Projeto;
    onConfirmation: (data: any) => void;
    onCancel: () => void;
}

const InfoBoxTitle = styled.h4({

})

const InfoBoxLabel = styled.strong({
    marginRight: "7px",
    textAlign: "start"
})

interface InfoBoxItemProperties {
    direction: "column" | "row"
}
const InfoBoxItem = styled.div<InfoBoxItemProperties>((props) => ({
    display: "flex",
    flexDirection: props.direction,
    height: props.direction === "row" ? "18px" : "inherit"
}))

const InfoBoxContainer = styled.div({
    display: "flex",
    flexDirection: "column"
})

const ResumoRevisao: FC<ResumoRevisaoProperties> = ({
    open,
    revisao,
    projeto,
    onConfirmation,
    onCancel
}) => {

    return (
        <>
            <Dialog open={open} >
                <DialogTitle>Resumo do projeto {revisao?.codigo_venda || ""}</DialogTitle>
                <DialogContent>
                    <InfoBoxContainer>
                        <InfoBoxTitle>Confirmar informações da revisão?</InfoBoxTitle>
                        <Divider />
                        {!!revisao?.disposicoes.length && (<InfoBoxItem direction="row">
                            <InfoBoxLabel>Grupo de estruturas:</InfoBoxLabel>
                            {revisao?.disposicoes?.map((d) => d.nome)?.join(", ") || ""}
                        </InfoBoxItem>)}

                        {!!revisao?.limitacao_projeto?.descricao && (<InfoBoxItem direction="column">
                            <InfoBoxLabel>Limitações do projeto:</InfoBoxLabel>
                            <span>{revisao?.limitacao_projeto?.descricao || ""}</span>
                        </InfoBoxItem>)}

                        <InfoBoxItem direction="column">
                            <InfoBoxLabel>Observações da limitação:</InfoBoxLabel>
                            {revisao?.limitacao_observacao.split(/\n/)?.map((l: any, index: number) => {
                                return <span key={`limitacao-obs-revisao-${revisao.codigo_venda}-${index}`}>{l}</span>
                            }) || ""}
                        </InfoBoxItem>

                        <InfoBoxItem direction="column">
                            <InfoBoxLabel>Observações da validade da proposta:</InfoBoxLabel>
                            {revisao?.observacao.split(/\n/)?.map((l: any, index: number) => {
                                return <span key={`obs-revisao-${revisao.codigo_venda}-${index}`}>{l}</span>
                            }) || ""}
                        </InfoBoxItem>

                        {!!revisao?.valor_servico && (<InfoBoxItem direction="row">
                            <InfoBoxLabel>Valor de serviço:</InfoBoxLabel>
                            R$ {revisao?.valor_servico || ""}
                        </InfoBoxItem>)}
                    </InfoBoxContainer>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            onCancel();
                        }}
                    >
                        Alterar
                    </Button>
                    <Button
                        color="primary"
                        disableElevation
                        variant="contained"
                        onClick={() => {
                            onConfirmation(projeto)
                        }}
                    >
                        Aceitar e salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export { ResumoRevisao }